import React from "react";
import PropTypes from "prop-types";

/**
 * Quantity control component
 * Reusable + / - buttons for quantity selection
 *
 * @component
 * @param {Object} props
 * @param {number} props.quantity - Current quantity value
 * @param {Function} props.onIncrease - Callback when + button clicked
 * @param {Function} props.onDecrease - Callback when - button clicked
 * @param {number} [props.min=1] - Minimum allowed quantity
 * @param {number} [props.max] - Maximum allowed quantity
 */
const QuantityControl = ({ quantity, onIncrease, onDecrease, min = 1, max }) => {
  const handleDecrease = () => {
    if (quantity > min) {
      onDecrease();
    }
  };

  const handleIncrease = () => {
    if (!max || quantity < max) {
      onIncrease();
    }
  };

  return (
    <div className="cart-plus-minus">
      <button onClick={handleDecrease} className="dec qtybutton">
        -
      </button>
      <input className="cart-plus-minus-box" type="text" value={quantity} readOnly />
      <button onClick={handleIncrease} className="inc qtybutton">
        +
      </button>
    </div>
  );
};

QuantityControl.propTypes = {
  quantity: PropTypes.number.isRequired,
  onIncrease: PropTypes.func.isRequired,
  onDecrease: PropTypes.func.isRequired,
  min: PropTypes.number,
  max: PropTypes.number,
};

export default QuantityControl;
